if (document.querySelector('.testimonials__carousel') != null) {
    new Splide( '.testimonials__carousel', {
        type : 'loop',
		perPage : 'auto',
		clones: 3,
		gap: '60px',
		autoScroll: {
			speed: 0.5,
			pauseOnHover: true,
			pauseOnFocus : false,
		},
		drag   : 'free',
		focus  : 'center',
		pagination : false,
		arrows : false,
		autoplay : true,
		rewind: false,
		autoStart : true,
		breakpoints: {
			670: {
				perPage: 1,
				autoScroll: {
					speed: 0.5,
				},
			},
		}
    }).mount(window.splide.Extensions); 
}